import { AccountantDTO } from './accountant'

export const UserAgreementType = {
    AnnualSelfAssessmentSubscription: 'AnnualSelfAssessmentSubscription',
    CompanyReturn: 'CompanyReturn',
    CompanySubscription: 'CompanySubscription',
    SelfAssessment: 'SelfAssessment',
    Subscription: 'Subscription',
    TaxConsultation: 'TaxConsultation',
    TaxRegistration: 'TaxRegistration',
    TieredSelfAssessment: 'TieredSelfAssessment',
} as const

export interface UserAgreementDTO {
    userId: number
    termsOfEngagementType: keyof typeof UserAgreementType
    agreementText: string | null
    signedDateUTC: string | null
}

export interface UserAgreementDraftDTO {
    userId: number
    accountantId: AccountantDTO['id']
    agreementText: string | null
}

export type TaxConsultationAgreementDTO = UserAgreementDTO & {
    taxConsultationId: number | null
    termsOfEngagementType: 'TaxConsultation'
}
